import React from 'react';
import { useTheme } from '../contexts/ThemeContext';
import { Moon, Sun } from 'lucide-react';

export const ThemeToggle: React.FC = () => {
  const { theme, toggleTheme } = useTheme();

  return (
    <div className="flex items-center border border-gray-300 dark:border-gray-600 rounded-full p-1 bg-gray-100 dark:bg-gray-700">
      <button
        onClick={() => theme === 'dark' && toggleTheme()}
        className={`flex items-center justify-center p-1 rounded-full transition-colors ${
          theme === 'light' 
            ? 'bg-white text-yellow-500 shadow-sm' 
            : 'text-gray-400 hover:text-gray-600 dark:hover:text-gray-200'
        }`}
        aria-label="Light mode"
      >
        <Sun className="h-4 w-4" />
      </button>
      <button
        onClick={() => theme === 'light' && toggleTheme()}
        className={`flex items-center justify-center p-1 rounded-full transition-colors ${
          theme === 'dark' 
            ? 'bg-gray-800 text-blue-400 shadow-sm' 
            : 'text-gray-400 hover:text-gray-600 dark:hover:text-gray-200'
        }`}
        aria-label="Dark mode"
      >
        <Moon className="h-4 w-4" />
      </button>
    </div>
  );
}; 